








































import Vue from 'vue'
import TitleName from '../atoms/TitleName.vue'
import NewContentHeaderSectionManabi from '../organisms/NewContentHeaderSectionManabi.vue'
import ContentSectionManabi from '../organisms/ContentSectionManabi.vue'
import NewReturnButton from '../atoms/NewReturnButton.vue'
import { icons } from '@/constants/icons'
import { Contract, Grade } from '@/types/Contract'

type DataType = {
  icons?: Record<string, string>
  subjects: Array<{
    name: string
    furigana: string
    anchor: string
    color: string
    subject_id?: number
    backgroundColor: string
  }>
  childRefs: Record<string, HTMLElement[]>
}

export default Vue.extend({
  components: {
    TitleName,
    NewContentHeaderSectionManabi,
    ContentSectionManabi,
    NewReturnButton
  },
  data(): DataType {
    return {
      icons: icons,
      subjects: [
        {
          name: '国語',
          furigana: '国語',
          anchor: 'japanese',
          color: 'white',
          backgroundColor: '#ff7f05',
          subject_id: 1,
        },
        {
          name: '算数',
          furigana: '算数',
          anchor: 'math',
          color: 'white',
          backgroundColor: '#3ea8bb',
          subject_id: 2,
        },
        {
          name: '思考の達人ツール',
          furigana: (
            (this.$store.state.grade && parseInt(this.$store.state.grade.name[1]) < 5)
               ? '<ruby>思考<rt>しこう</rt></ruby>の<ruby>達人<rt>たつじん</rt></ruby>ツール'
               : '思考の達人ツール'
          ),
          anchor: 'thinking_tool',
          color: 'white',
          backgroundColor: '#52bb70',
          subject_id: 4,
        },
        {
          name: '複合教科問題',
          furigana:
            '<ruby>複合教科問題<rt>ふくごうきょうかもんだい</rt></ruby>',
          anchor: 'combination_problem',
          color: 'white',
          backgroundColor: '#8677c3',
          subject_id: 3,
        },
        {
          name: 'えい語',
          furigana: 'えい<ruby>語<rt>ご</rt></ruby>',
          anchor: 'English1',
          color: 'white',
          backgroundColor: '#fc7e7e',
          subject_id: 5,
        },
      ],
      childRefs: {} as Record<string, HTMLElement[]>,
    }
  },
  computed: {
    year(): number {
      return this.$store.state.year
    },
    month(): number | null {
      return this.$store.state.month
    },
    rootPath(): string {
      return process.env.VUE_APP_ROOT_PATH || ''
    },
    newRootPath(): string {
      return process.env.VUE_APP_NEW_ROOT_PATH || ''
    },
    selectedContract(): Contract | null {
      if (!this.year || !this.month) return null
      const selectedMonth = this.year.toString() + ('0' + this.month).slice(-2)
      return (this.$store.state.contracts as Contract[]).find((contract) => contract.month === selectedMonth) || null
    },
    selectedGrade(): Grade | null {
      const contract = this.selectedContract
      return contract ? contract.grade : null
    },
    untilMonth(): string {
      if (!this.month) return ''
      const year = this.$store.state.year as number
      const month = this.$store.state.month as number

      // grade6 month6~3
      if (this.selectedContract?.course === 'S6') {
        if (month >= 6) {
          return (year + 1) + '年' + 4
        } else if (month <= 3) {
          return year + '年' + 4
        }
      }

      if (month > 1){
        return (year + 1) + '年' + (month - 1)
      } else {
        return year + '年' + 12
      }
    },
  },
  mounted() {
    // 背景をレンガ調から白に変更
    document.body.style.backgroundImage = 'none'
    document.body.style.backgroundColor = '#ffffff'
  },
  beforeDestroy() {
    // ページ離脱時に背景を元に戻す
    document.body.style.backgroundImage = ''
    document.body.style.backgroundColor = ''
  },
  async created() {
    this.$store.commit('SET_CONTENTS', {})

    this.$store.dispatch('getCurrentDate')

    await this.$store.dispatch('getNewContents')

    const yearMonthValues = Object.entries(this.$store.state.contents).map(([t, ]) => (t))

    const initialDisplayIssue = yearMonthValues.sort((a, b) => Number(b) - Number(a))[0]

    this.$store.commit('SET_MONTH', { month: parseInt(initialDisplayIssue.slice(4)) })
    this.$store.commit('SET_YEAR', { year: parseInt(initialDisplayIssue.slice(0, 4)) })
  },
  methods: {
    scrollToAnchorPoint(refName: string): void {
      const testRef = this.childRefs[refName]
      testRef[0].scrollIntoView({ behavior: 'smooth' })
    },
    navigateToTop(): void {
      this.$router.push('/new/contents')
    }
  },
})
